import React from "react";
import PropTypes from "prop-types";

const FormHeader = ({ title, subtitle }) => (
  <div className="grid grid-cols-1 gap-3">
    <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold text-black">{title}</h2>
    <h4 className="text-sm md:text-base font-medium text-black/45">{subtitle}</h4>
  </div>
);

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
export default FormHeader;
